import { MicroMClient, StatusValues } from "@mcurros2/microm";
import { IconStatusChange } from "@tabler/icons-react";

export const ActivoIcon = IconStatusChange;
export const ActivoHelpText = "* Valores para estado Activo";

export class estActivo extends StatusValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_status_id.value = "Activo";
        this.def.columns.c_status_id.defaultValue = "Activo";
        this.Title = "Estado Activo";
        this.HelpText = ActivoHelpText;
        this.Icon = ActivoIcon;
    }
}